import React from 'react';
import { number } from 'prop-types';
import './styles.scss';

export const RecordingBar = ({ progress }) => {
  return (
    <div className="recording-bar">
      <div
        className="recording-bar__progress"
        style={{ ['---progress']: `${progress}%` }}
      />
    </div>
  );
};

RecordingBar.propTypes = {
  progress: number,
};

RecordingBar.defaultProps = {
  progress: 0,
};
